import { createApp } from 'vue';
import App from './App.vue';

import router from './router/clean.js';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import en from 'element-plus/lib/locale/lang/en'; // Correct locale import

import i18n from '@/core/plugins/i18n';
// import VueShopifyDraggable from 'vue-shopify-draggable';

import ApiService from '@/core/services/ApiService';
// import { initApexCharts } from '@/core/plugins/apexcharts';
import { initInlineSvg } from '@/core/plugins/inline-svg';
import { initVeeValidate } from '@/core/plugins/vee-validate';

import '@/core/plugins/prismjs';
import 'bootstrap';

// Debug: Log environment variables (remove in production)
// if (process.env.NODE_ENV === 'development') {
// 	console.log('🔧 Development Mode Active');
// 	console.log('📡 API URL:', process.env.VUE_APP_API_URL);
// 	console.log('🌍 NODE_ENV:', process.env.NODE_ENV);
// }

const app = createApp(App);

// Configure ElementPlus with the correct options
app.use(ElementPlus, {
  size: 'medium', // Use a valid size option
  zIndex: 3000    // Optional: Set global zIndex
});

// Set the global locale for ElementPlus
app.config.globalProperties.$ELEMENT = { locale: en }; // Set the locale globally

app.use(store);
app.use(router);
// app.use(VueShopifyDraggable);

ApiService.init(app);
//initApexCharts(app);
initInlineSvg(app);
initVeeValidate();

app.use(i18n);

app.mount('#app');